module.exports = "<mat-toolbar color=\"primary\">\n    Exalted Combat\n</mat-toolbar>\n<router-outlet></router-outlet>\n"